import { SidebarProvider } from "@/components/ui/sidebar"
import { TooltipProvider } from "@/components/ui/tooltip"
import { AppSidebar } from "@/components/app-sidebar"
import { SidebarInset } from "@/components/ui/sidebar"
import Toolbar from "./Toolbar"
import MainContentWrapper from "./MainContentWrapper"
import Footer from "./Footer"
import { useLayout } from "@/providers/LayoutProvider"

export default function LayoutWrapper({ children }) {
    const { layout } = useLayout();
    return (
        <TooltipProvider>
            <SidebarProvider>
                {/* {layout.showSidebar && <AppSidebar />} */}
                <SidebarInset>
                    {layout.showToolbar && <Toolbar />}
                    <MainContentWrapper>
                        {children}
                    </MainContentWrapper>
                    {layout.showFooter && <Footer />}
                </SidebarInset>
            </SidebarProvider>
        </TooltipProvider>
    )
}